exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3EAmsecFZQg8vV8SD0fh6B{height:100%}._3UPSJytv7IOCq6ePE8m8lF{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.p_uExkHiuipDYl340-jzY{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1}.kQb2_RHoWGwkXlBRzg3f2{font-size:1.14286rem;font-weight:600;line-height:1.71429rem}.kQb2_RHoWGwkXlBRzg3f2:first-child{margin-top:0}.kQb2_RHoWGwkXlBRzg3f2:only-child{margin-bottom:0;margin-top:0}.p_uExkHiuipDYl340-jzY p:last-child{margin-bottom:0}@media only screen and (min-width:640px){.pzV-oaW4qDQd3OXtk3JKA{display:none}}._2ReNy0VELNbbDg63uCxyqA{display:none;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;font-size:1.28571rem}@media only screen and (min-width:640px){._2ReNy0VELNbbDg63uCxyqA{display:block}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ProgressTestCard": "_3EAmsecFZQg8vV8SD0fh6B",
	"ProgressTestCard_wrapper": "_3UPSJytv7IOCq6ePE8m8lF",
	"ProgressTestCard_wrapper_narrative": "p_uExkHiuipDYl340-jzY",
	"ProgressTestCard_wrapper_narrative_subTitle": "kQb2_RHoWGwkXlBRzg3f2",
	"ProgressTestCard_wrapper_scoreText": "pzV-oaW4qDQd3OXtk3JKA",
	"ProgressTestCard_wrapper_radialScore": "_2ReNy0VELNbbDg63uCxyqA"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReport/StudentReportView/ProgressTestCard/style.postcss
// module id = 1491
// module chunks = 0